(function () {
  'use strict';

  var root = document.querySelector('[data-laboo-reviews-page]');
  if (!root) return;

  var widget = root.querySelector('[data-laboo-reviews-widget]');
  if (!widget) return;

  var labels = {
    more: root.dataset.moreLabel || 'More',
    less: root.dataset.lessLabel || 'Less',
    search: root.dataset.searchLabel || 'Search reviews',
    sort: root.dataset.sortLabel || 'Sort reviews',
    write: root.dataset.writeLabel || 'Write a review',
    showMore: root.dataset.showMoreLabel || 'Show more reviews',
    purchased: root.dataset.purchasedLabel || 'Purchased:',
    previous: root.dataset.previousLabel || 'Previous',
    next: root.dataset.nextLabel || 'Next'
  };

  var reviewsPerPage = Number(root.dataset.reviewsPerPage) || 36;

  function formatHeroCount() {
    var count = root.dataset.reviewCount;
    var countElement = root.querySelector('.laboo-reviews-score__count');
    if (!count || !countElement) return;

    var formatted = Number(count).toLocaleString(document.documentElement.lang || undefined);
    countElement.textContent = countElement.textContent.replace(count, formatted);
  }

  function optimiseProductImage(image, review) {
    if (image.dataset.labooReviewImageReady === 'true') return;

    var productLink = review.querySelector('.jdgm-rev__prod-link');
    var productName = productLink ? productLink.textContent.trim() : '';
    if (productName) image.alt = productName;

    image.loading = 'lazy';
    image.decoding = 'async';

    var source = image.getAttribute('src');
    if (source && source.indexOf('cdn.shopify.com') !== -1) {
      try {
        var url = new URL(source, window.location.origin);
        url.searchParams.set('width', '320');
        image.src = url.toString();
      } catch (error) {
        // Keep the original URL if it cannot be parsed.
      }
    }

    image.dataset.labooReviewImageReady = 'true';
  }

  function makeDateSemantic(timestamp) {
    if (timestamp.dataset.labooDateReady === 'true') return;
    if (timestamp.querySelector('time')) return;

    var label = timestamp.textContent.trim();
    var rawDate = timestamp.dataset.content || label;
    var parsed = new Date(rawDate);
    var time = document.createElement('time');

    time.textContent = label;
    if (!Number.isNaN(parsed.getTime())) {
      time.dateTime = parsed.toISOString().slice(0, 10);
    }

    timestamp.textContent = '';
    timestamp.appendChild(time);
    timestamp.dataset.labooDateReady = 'true';
  }

  function addReviewExpander(body) {
    if (body.dataset.labooClampReady === 'true') return;
    body.dataset.labooClampReady = 'true';
    body.classList.add('laboo-review-body--clamped');

    window.requestAnimationFrame(function () {
      if (body.scrollHeight <= body.clientHeight + 2) return;

      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'laboo-review-more';
      button.textContent = labels.more;
      button.setAttribute('aria-expanded', 'false');

      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded));
        button.textContent = expanded ? labels.more : labels.less;
        body.classList.toggle('laboo-review-body--clamped', expanded);
        body.classList.toggle('laboo-review-body--expanded', !expanded);
      });

      body.insertAdjacentElement('afterend', button);
    });
  }

  function buildReviewCard(review) {
    if (review.dataset.labooCardReady === 'true') return;

    var wrapper = review.querySelector(':scope > .jdgm-rev-wrapper');
    var contentColumn = review.querySelector('.jdgm-rev-content-column');

    /* Judge.me uses a flatter card structure for reviews loaded after page one. */
    if (!contentColumn) {
      contentColumn = document.createElement('div');
      contentColumn.className = 'jdgm-rev-content-column';

      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'jdgm-rev-wrapper';
        Array.from(review.childNodes).forEach(function (node) { contentColumn.appendChild(node); });
        wrapper.appendChild(contentColumn);
        review.appendChild(wrapper);
      } else {
        Array.from(wrapper.childNodes).forEach(function (node) {
          if (node.nodeType === 1 && node.classList.contains('jdgm-rev-image-column')) return;
          contentColumn.appendChild(node);
        });
        wrapper.appendChild(contentColumn);
      }
    }

    var header = review.querySelector('.jdgm-rev__header');
    var content = review.querySelector('.jdgm-rev__content');
    if (!contentColumn || !header || !content) return;

    var reviewTitle = review.querySelector('.jdgm-rev__title');
    var reviewBody = review.querySelector('.jdgm-rev__body');
    var hasWrittenReview = Boolean(
      (reviewTitle && reviewTitle.textContent.trim()) ||
      (reviewBody && reviewBody.textContent.trim())
    );
    review.classList.toggle('laboo-review-card--rating-only', !hasWrittenReview);

    var meta = document.createElement('div');
    meta.className = 'laboo-review-card__meta';

    var profile = review.querySelector('.jdgm-row-profile');
    var timestamp = review.querySelector('.jdgm-rev__timestamp');
    var product = review.querySelector('.jdgm-row-product');
    var productPrefix = product && product.querySelector('.jdgm-rev__prod-link-prefix');

    if (productPrefix) productPrefix.textContent = labels.purchased + ' ';
    if (profile) meta.appendChild(profile);
    if (timestamp) meta.appendChild(timestamp);
    if (product) meta.appendChild(product);

    contentColumn.appendChild(meta);
    review.dataset.labooCardReady = 'true';
  }

  function enhanceReview(review) {
    review.querySelectorAll('a[href]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        if (url.origin === window.location.origin) {
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
      } catch (error) {
        // Leave third-party links untouched.
      }
    });

    var image = review.querySelector('.jdgm-rev-product-img');
    if (image) optimiseProductImage(image, review);

    review.querySelectorAll('.jdgm-rev__timestamp').forEach(makeDateSemantic);

    var body = review.querySelector('.jdgm-rev__body');
    if (body) addReviewExpander(body);

    buildReviewCard(review);
  }

  function organiseControls() {
    var nativeWidget = widget.querySelector('.jdgm-all-reviews-widget');
    if (!nativeWidget) return;

    var controls = nativeWidget.querySelector('.laboo-reviews-controls');
    if (!controls) {
      controls = document.createElement('div');
      controls.className = 'laboo-reviews-controls';

      var toolbar = document.createElement('div');
      toolbar.className = 'laboo-reviews-controls__toolbar';
      controls.appendChild(toolbar);

      var firstBody = nativeWidget.querySelector('.jdgm-all-reviews__body, .jdgm-shop-reviews__body');
      if (firstBody) nativeWidget.insertBefore(controls, firstBody);
    }

    var controlsToolbar = controls.querySelector('.laboo-reviews-controls__toolbar');
    var searchRow = nativeWidget.querySelector('.jdgm-row-search');
    var actionsRow = nativeWidget.querySelector('.jdgm-row-actions');
    var subtabs = nativeWidget.querySelector('.jdgm-subtab');

    if (searchRow && searchRow.parentElement !== controlsToolbar) controlsToolbar.appendChild(searchRow);
    if (actionsRow && actionsRow.parentElement !== controlsToolbar) controlsToolbar.appendChild(actionsRow);
    if (subtabs && subtabs.parentElement !== controls) controls.appendChild(subtabs);
  }

  function setupPagination() {
    var nativeWidget = widget.querySelector('.jdgm-all-reviews-widget');
    if (!nativeWidget) return;

    var frame = nativeWidget.querySelector('.laboo-reviews-list-frame');
    if (!frame) {
      var bodies = Array.from(nativeWidget.querySelectorAll('.jdgm-all-reviews__body, .jdgm-shop-reviews__body'));
      if (!bodies.length) return;

      frame = document.createElement('div');
      frame.className = 'laboo-reviews-list-frame';
      nativeWidget.insertBefore(frame, bodies[0]);
      bodies.forEach(function (body) { frame.appendChild(body); });

      var paginationControls = document.createElement('div');
      paginationControls.className = 'laboo-reviews-pagination-controls';

      var loadMoreButton = document.createElement('button');
      loadMoreButton.type = 'button';
      loadMoreButton.className = 'laboo-reviews-load-more';
      loadMoreButton.textContent = labels.showMore;
      loadMoreButton.setAttribute('aria-controls', 'laboo-review-results');

      var pagination = document.createElement('nav');
      pagination.className = 'laboo-reviews-pagination';
      pagination.setAttribute('aria-label', root.querySelector('#customer-reviews-title')?.textContent.trim() || 'Reviews');
      frame.id = 'laboo-review-results';
      paginationControls.appendChild(loadMoreButton);
      paginationControls.appendChild(pagination);
      frame.insertAdjacentElement('afterend', paginationControls);

      var state = {
        currentPage: 1,
        visibleThroughPage: 1,
        loading: false,
        initialising: true,
        exhausted: new WeakSet(),
        searchTimer: null
      };

      function activeBody() {
        return Array.from(frame.querySelectorAll('.jdgm-all-reviews__body, .jdgm-shop-reviews__body')).find(function (body) {
          return window.getComputedStyle(body).display !== 'none';
        });
      }

      function writtenReviews(body) {
        if (!body) return [];
        return Array.from(body.querySelectorAll(':scope > .jdgm-rev')).filter(function (review) {
          return !review.classList.contains('laboo-review-card--rating-only');
        });
      }

      function waitForMoreReviews(body, previousCount) {
        return new Promise(function (resolve) {
          var settled = false;
          var timeout;
          var loadingObserver = new MutationObserver(function () {
            if (body.querySelectorAll(':scope > .jdgm-rev').length > previousCount) finish(true);
          });

          function finish(loaded) {
            if (settled) return;
            settled = true;
            window.clearTimeout(timeout);
            loadingObserver.disconnect();
            resolve(loaded);
          }

          loadingObserver.observe(body, { childList: true });
          timeout = window.setTimeout(function () { finish(false); }, 6000);
        });
      }

      async function loadUntil(body, targetCount) {
        var attempts = 0;

        while (writtenReviews(body).length < targetCount && !state.exhausted.has(body) && attempts < 8) {
          var loadMore = nativeWidget.querySelector('.jdgm-all-reviews-page__load-more');
          var loadMoreWrapper = loadMore && loadMore.closest('.jdgm-all-reviews-page__load-more-wrapper');
          if (!loadMore || (loadMoreWrapper && loadMoreWrapper.classList.contains('jdgm-hidden'))) {
            state.exhausted.add(body);
            break;
          }

          var previousCount = body.querySelectorAll(':scope > .jdgm-rev').length;
          attempts += 1;
          loadMore.click();

          var loaded = await waitForMoreReviews(body, previousCount);
          if (!loaded) {
            state.exhausted.add(body);
            break;
          }

          body.querySelectorAll(':scope > .jdgm-rev').forEach(enhanceReview);
        }
      }

      function makePaginationButton(page, label, text, modifier) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'laboo-reviews-pagination__button' + (modifier ? ' ' + modifier : '');
        button.textContent = text;
        button.setAttribute('aria-label', label);

        if (page === state.currentPage && !modifier) {
          button.classList.add('is-current');
          button.setAttribute('aria-current', 'page');
        }

        button.addEventListener('click', function () { goToPage(page); });
        return button;
      }

      function paginationPages() {
        var first = Math.max(1, state.currentPage - 1);
        var last = state.currentPage + 1;
        var pages = [];

        if (first > 1) pages.push(1);
        if (first > 2) pages.push('ellipsis');
        for (var page = first; page <= last; page += 1) pages.push(page);
        return pages;
      }

      function renderPagination(body) {
        var reviews = writtenReviews(body);
        var hasNextLoadedPage = reviews.length > state.currentPage * reviewsPerPage;
        var hasNextPage = hasNextLoadedPage || !state.exhausted.has(body);
        var hasMoreLoadedReviews = reviews.length > state.visibleThroughPage * reviewsPerPage;
        var hasMoreReviews = hasMoreLoadedReviews || !state.exhausted.has(body);
        var renderSignature = [state.currentPage, state.visibleThroughPage, state.loading, hasNextPage, hasMoreReviews].join('|');
        if (pagination.dataset.renderSignature === renderSignature) return;
        pagination.dataset.renderSignature = renderSignature;
        pagination.textContent = '';
        pagination.classList.toggle('is-loading', state.loading);
        pagination.setAttribute('aria-busy', String(state.loading));
        paginationControls.classList.toggle('is-loading', state.loading);
        paginationControls.setAttribute('aria-busy', String(state.loading));
        loadMoreButton.hidden = !hasMoreReviews;
        loadMoreButton.disabled = state.loading || !hasMoreReviews;

        var previous = makePaginationButton(
          Math.max(1, state.currentPage - 1),
          labels.previous,
          '‹',
          'laboo-reviews-pagination__button--direction'
        );
        previous.disabled = state.currentPage === 1 || state.loading;
        pagination.appendChild(previous);

        paginationPages().forEach(function (page) {
          if (page === 'ellipsis') {
            var ellipsis = document.createElement('span');
            ellipsis.className = 'laboo-reviews-pagination__ellipsis';
            ellipsis.textContent = '…';
            ellipsis.setAttribute('aria-hidden', 'true');
            pagination.appendChild(ellipsis);
            return;
          }

          var pageButton = makePaginationButton(page, String(page), String(page));
          pageButton.disabled = state.loading || (page > state.currentPage && !hasNextPage);
          pagination.appendChild(pageButton);
        });

        var next = makePaginationButton(
          state.currentPage + 1,
          labels.next,
          '›',
          'laboo-reviews-pagination__button--direction'
        );
        next.disabled = !hasNextPage || state.loading;
        pagination.appendChild(next);

        var loading = document.createElement('span');
        loading.className = 'laboo-reviews-pagination__loading';
        loading.setAttribute('aria-hidden', 'true');
        pagination.appendChild(loading);
      }

      function showPage(body) {
        var start = (state.currentPage - 1) * reviewsPerPage;
        var end = state.visibleThroughPage * reviewsPerPage;

        writtenReviews(body).forEach(function (review, index) {
          review.classList.toggle('laboo-review-card--page-hidden', index < start || index >= end);
        });

        frame.querySelectorAll('.jdgm-all-reviews__body, .jdgm-shop-reviews__body').forEach(function (otherBody) {
          if (otherBody === body) return;
          writtenReviews(otherBody).forEach(function (review, index) {
            review.classList.toggle('laboo-review-card--page-hidden', index >= reviewsPerPage);
          });
        });
      }

      async function goToPage(page) {
        if (state.loading || page < 1) return;

        var body = activeBody();
        if (!body) return;

        state.loading = true;
        state.currentPage = page;
        state.visibleThroughPage = page;
        renderPagination(body);
        frame.classList.add('is-loading');

        await loadUntil(body, page * reviewsPerPage);

        var availablePages = Math.max(1, Math.ceil(writtenReviews(body).length / reviewsPerPage));
        if (state.exhausted.has(body) && state.currentPage > availablePages) {
          state.currentPage = availablePages;
          state.visibleThroughPage = availablePages;
        }

        showPage(body);
        state.loading = false;
        frame.classList.remove('is-loading');
        renderPagination(body);
      }

      async function showMoreReviews() {
        if (state.loading) return;

        var body = activeBody();
        if (!body) return;

        var targetPage = state.visibleThroughPage + 1;
        state.loading = true;
        renderPagination(body);
        frame.classList.add('is-loading');

        await loadUntil(body, targetPage * reviewsPerPage);

        var availablePages = Math.max(1, Math.ceil(writtenReviews(body).length / reviewsPerPage));
        state.visibleThroughPage = Math.min(targetPage, availablePages);

        showPage(body);
        state.loading = false;
        frame.classList.remove('is-loading');
        renderPagination(body);
      }

      loadMoreButton.addEventListener('click', showMoreReviews);

      function refreshPagination() {
        var body = activeBody();
        if (!body) return;

        if (state.initialising) {
          showPage(body);
          renderPagination(body);
          return;
        }

        if (
          !state.loading &&
          !state.exhausted.has(body) &&
          writtenReviews(body).length < state.visibleThroughPage * reviewsPerPage
        ) {
          window.setTimeout(function () { goToPage(state.currentPage); }, 0);
          return;
        }

        showPage(body);
        renderPagination(body);
      }

      function resetPagination(delay) {
        window.setTimeout(function () {
          state.currentPage = 1;
          state.visibleThroughPage = 1;
          state.exhausted = new WeakSet();
          goToPage(1);
        }, delay || 0);
      }

      nativeWidget.addEventListener('click', function (event) {
        if (event.target.closest('.jdgm-subtab__name')) resetPagination(120);
      });

      nativeWidget.addEventListener('change', function (event) {
        if (event.target.matches('.jdgm-sort-dropdown')) resetPagination(120);
      });

      nativeWidget.addEventListener('input', function (event) {
        if (!event.target.matches('.jdgm-review-search')) return;
        window.clearTimeout(state.searchTimer);
        state.searchTimer = window.setTimeout(function () { resetPagination(180); }, 450);
      });

      frame._labooPagination = {
        refresh: refreshPagination,
        reset: resetPagination
      };

      window.setTimeout(function () {
        state.initialising = false;
        goToPage(1);
      }, 700);
    }

    if (frame._labooPagination) window.requestAnimationFrame(frame._labooPagination.refresh);
  }

  function enhanceControls() {
    var customWrite = root.querySelector('[data-laboo-write-review]');

    widget.querySelectorAll('.jdgm-review-search').forEach(function (input) {
      input.placeholder = labels.search;
      input.setAttribute('aria-label', labels.search);
    });

    widget.querySelectorAll('.jdgm-sort-dropdown').forEach(function (select) {
      select.setAttribute('aria-label', labels.sort);
    });

    widget.querySelectorAll('.jdgm-write-rev-link').forEach(function (link) {
      link.textContent = labels.write;
    });

    if (customWrite && customWrite.dataset.labooReviewReady !== 'true') {
      customWrite.addEventListener('click', function () {
        var currentNativeWrite = widget.querySelector('.jdgm-write-rev-link');
        if (!currentNativeWrite) return;

        var currentForm = widget.querySelector('.jdgm-form-wrapper');
        var formWasOpen = currentForm && window.getComputedStyle(currentForm).display !== 'none';
        currentNativeWrite.click();

        /* Judge.me creates this form lazily; its first click can stop after insertion. */
        if (!formWasOpen) {
          window.setTimeout(function () {
            var loadedForm = widget.querySelector('.jdgm-form-wrapper');
            var loadedWrite = widget.querySelector('.jdgm-write-rev-link');
            if (loadedForm && loadedWrite && window.getComputedStyle(loadedForm).display === 'none') {
              loadedWrite.click();
            }
          }, 250);
        }
      });
      customWrite.dataset.labooReviewReady = 'true';
    }

    organiseControls();
  }

  var enhancementQueued = false;
  function enhance() {
    enhancementQueued = false;
    enhanceControls();
    widget.querySelectorAll('.jdgm-rev').forEach(enhanceReview);
    setupPagination();
  }

  function queueEnhancement() {
    if (enhancementQueued) return;
    enhancementQueued = true;
    window.requestAnimationFrame(enhance);
  }

  formatHeroCount();
  enhance();

  var observer = new MutationObserver(function (mutations) {
    var hasExternalMutation = mutations.some(function (mutation) {
      var target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
      return !target || !target.closest('.laboo-reviews-pagination-controls');
    });

    if (hasExternalMutation) queueEnhancement();
  });
  observer.observe(widget, { childList: true, subtree: true });
})();
